<template>
    <div>
        <pda-header title='关联出入库'></pda-header>
        <div style="width: 100%;text-align: center;margin-top: 40px">
            <div>
                <span>上游单据编号：</span>
                <input>
                <van-button type="info" size="mini" style="margin-left: 10px" @click="go_url()">扫描</van-button>
            </div>
            <!--<van-uploader :after-read="onRead">-->
            <!--<van-icon name="photograph" />-->
            <!--</van-uploader>-->
        </div>
    </div>
</template>
<script>
  import { Toast } from 'vant';
  import Quagga from 'quagga'
  export default {
    name: "selectData",
    data(){
      return {
        message:'',
      }
    },
    mounted () {
    },
    methods:{
      go_url(){
        router.push("/fillingGoods")
      },
      onRead(file) {
        Quagga.decodeSingle({
          readers: ['code_128_reader'],
          locate: true, // try to locate the barcode in the image
          src: file.content // or 'data:image/jpg;base64,' + data
        }, function(result){
          console.log(result);
          Toast(result);
        });
        // console.log(file.content)
      }
    }
  }
</script>

<style lang="less">
</style>